import RaceDetails from './RaceDetails';

export default RaceDetails;
